<template>
  <div class="card-header">
    <div class="card-header__titles">
      <router-link :to="back.to" class="card-header__back">
        <SatIcon name="back" :size="16" />
        {{ back.label }}
      </router-link>
      <h1 class="card-header__title">
        {{ subaccount.name }}
        <span class="sat-chip _accent">{{ $t(`platform.card.types.${kind}`) }}</span>
      </h1>
      <div class="card-header__meta">
        <span>ID {{ subaccount.id }}</span>
        <span v-if="paymentModel">{{ paymentModel }}</span>
        <a v-if="subaccount.url" :href="subaccount.url" target="_blank" rel="noopener" class="card-header__url">
          {{ subaccount.url }}
          <SatIcon name="external" :size="13" />
        </a>
      </div>
    </div>
    <div class="card-header__actions">
      <button type="button" class="btn _bg-gray sat-btn-inline" @click="openStatistic">
        <SatIcon name="chart" :size="16" />
        {{ $t("platform.card.statistic") }}
      </button>
      <button type="button" class="btn _bg-green sat-btn-inline" @click="$emit('code')">
        <SatIcon :name="isSite ? 'code' : 'link'" :size="16" />
        {{ $t(`platforms.table.${isSite ? "get_code" : "get_link"}`) }}
      </button>
    </div>
  </div>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";
import { isSiteKind, KIND_DIRECTLINK, paymentModelOf } from "@/components/PlatformCard/subaccountPayload";

export default {
  name: "CardHeader",
  components: { SatIcon },
  props: {
    subaccount: {
      type: Object,
      required: true,
    },
    kind: {
      type: String,
      required: true,
    },
  },
  computed: {
    isSite() {
      return isSiteKind(this.kind);
    },
    back() {
      return this.kind === KIND_DIRECTLINK ? { to: "/directlink", label: this.$t("platform.card.back_directlink") } : { to: "/platforms", label: this.$t("platform.card.back") };
    },
    paymentModel() {
      return this.kind === KIND_DIRECTLINK ? "" : paymentModelOf(this.subaccount.payment_model).title;
    },
  },
  methods: {
    // The statistic page opens filtered by the platform it finds there, as from the list of platforms
    openStatistic() {
      localStorage.setItem("statisticPlatform", this.subaccount.id);
      this.$router.push("/statistic");
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px 24px;
  margin-bottom: 18px;
}

.card-header__titles {
  min-width: 0;
}

.card-header__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--sat-muted);

  &:hover {
    color: var(--sat-accent);
  }
}

.card-header__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 22px;
  word-break: break-word;
  color: var(--sat-text);

  @media screen and (min-width: 768px) {
    font-size: 26px;
  }
}

.card-header__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 8px;
  font-size: 14px;
  color: var(--sat-muted);
}

.card-header__url {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  word-break: break-all;
  color: var(--sat-accent);
}

.card-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .btn {
    height: 44px;
  }

  @media (max-width: 575px) {
    width: 100%;

    .btn {
      flex: 1 1 0;
      justify-content: center;
    }
  }
}
</style>
